import { render, staticRenderFns } from "./PracticeTest.vue?vue&type=template&id=0f5dec81&"
import script from "./PracticeTest.vue?vue&type=script&lang=js&"
export * from "./PracticeTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports